import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import { colourOptions, finishOptions } from 'constants/finishing';

const ShaftGuard = ({ control, tableView }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Shaft Guard</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.shaftGuardQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.shaftGuardMaterial'
                type='text'
                control={control}
                label='Material'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.shaftGuardPaint'
                control={control}
                label='Paint'
                creatable={true}
                options={colourOptions}
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.shaftGuardNotes'
                type='text'
                control={control}
                label='Notes'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.shaftGuardFinish'
                control={control}
                label='Finish'
                options={finishOptions}
                style={{width: '14%', marginRight: '1%'}}
            />
        </>   
    );
};

export default ShaftGuard;
